import { render } from "./PagCurso.vue?vue&type=template&id=7bdfe48e&scoped=true"
const script = {}

import "./PagCurso.vue?vue&type=style&index=0&id=7bdfe48e&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bdfe48e"]])

export default __exports__